<template>
  <div>
    <div class="outmain">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('order.revoke.listTitle') }}</span>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('order.orderStatus')">
              <el-select v-model="formInline.state" :placeholder="$t('common.pleaseSelect')" @change="onSearch">
                <el-option v-for="item in cancelStateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('order.orderTime')" class="mar_l20">
              <el-date-picker v-model="formInline.timeData" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
            </el-form-item>
          </div>
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('order.orderNo')" class>
              <el-input v-model="formInline.outTradeNo" size="medium" :placeholder="$t('order.orderNoPh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.customerTel')" class="mar_l20">
              <el-input v-model="formInline.endTel" size="medium" :placeholder="$t('order.customerTelPh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.storeName')" class="mar_l20">
              <el-input v-model="formInline.storeName" size="medium" :placeholder="$t('order.storeNamePh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.riderName')" class>
              <el-input v-model="formInline.userName" size="medium" :placeholder="$t('order.riderNamePh')" @input="onSearch"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="ba_f mar_t20 pad_20">
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="storeName" :label="$t('order.revoke.storeInfo')"></el-table-column>
          <el-table-column prop="outTradeNo" :label="$t('order.orderNo')" min-width="100"></el-table-column>
          <el-table-column prop="createdAt" :label="$t('order.orderTime')"></el-table-column>
          <el-table-column prop="orderType" :label="$t('order.orderType')">
            <template slot-scope="scope">
              <div v-if="scope.row.orderType == 1">{{ $t('order.takeaway') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sourceName" :label="$t('order.revoke.orderSource')"></el-table-column>
          <el-table-column prop="money" :label="$t('order.revoke.orderTotal')" width="80" align="center"></el-table-column>
          <el-table-column prop="actualMoney" :label="$t('order.revoke.orderAmount')" width="80" align="center"></el-table-column>
          <el-table-column prop="startDetail" :label="$t('order.startAddress')" min-width="200">
            <template slot-scope="scope">
              <div>{{ $t('common.start') }}:{{ scope.row.startDetail }}</div>
              <div>{{ $t('common.end') }}:{{ scope.row.endDetail }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="tel" :label="$t('order.revoke.contactPhone')"></el-table-column>
          <el-table-column prop="userName" :label="$t('order.revoke.riderInfo')"></el-table-column>
          <el-table-column prop="state" :label="$t('order.orderStatus')" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.cancelState == 1">{{ $t('order.revoke.cancelling') }}</div>
              <div v-if="scope.row.cancelState == 2">{{ $t('order.revoke.cancelled') }}</div>
              <div v-if="scope.row.cancelState == 3">{{ $t('order.revoke.rejected') }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" width="250" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSeeEdit(scope.row.id)">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
              <el-button type="text" @click="handleCancelOrder(scope.row)">{{ $t('order.revoke.cancelOrder') }}</el-button>
              <el-button type="text" @click="handleRejectOrde(scope.row)">{{ $t('order.revoke.rejectOrder') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <order-info ref="orderInfo" v-if="dialogVisible" @close="dialogVisible = false"></order-info>
  </div>
</template>
<script>
import { orderList, orderInfo, deleteOrder, rejectOrder, cancelOrder } from '@/api/order';
import { changeDate } from '@/utils/index';
import OrderInfo from './components/order-info.vue';
export default {
  components: { OrderInfo },
  data() {
    return {
      formInline: {
        keyword: '',
        vipLabel: '',
        isBlack: '',
        userChannel: '',
        timeData: [],
        storeName: '',
        userName: '',
        endTel: '',
        state: '0',
        outTradeNo: ''
      },
      list: [],
      listLoading: true,
      dialogVisible: false,
      orderInfo: {},
      selectRows: '',
      page: {
        total: 0,
        pagesize: 10,
        currentPage: 1
      }
    };
  },
  computed: {
    cancelStateOptions() {
      return [
        { value: '0', label: this.$t('order.all') },
        { value: '1', label: this.$t('order.revoke.cancelling') },
        { value: '2', label: this.$t('order.revoke.cancelled') },
        { value: '3', label: this.$t('order.revoke.rejected') },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleSeeEdit(id) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.orderInfo.init(id);
      });
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteOrder'), null, async () => {
          const { msg } = await deleteOrder({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    handleCancelOrder(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.cancelOrder'), null, async () => {
          const { msg } = await cancelOrder({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    handleRejectOrde(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.rejectOrder'), null, async () => {
          const { msg } = await rejectOrder({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    onSearch() {
      this.fetchData();
    },
    async fetchData() {
      var params = { page: this.page.currentPage, type: 'cancelOrder' };
      if (this.formInline.storeName) params.storeName = this.formInline.storeName;
      if (this.formInline.userName) params.userName = this.formInline.userName;
      if (this.formInline.endTel) params.endTel = this.formInline.endTel;
      if (this.formInline.state) params.cancelState = this.formInline.state;
      if (this.formInline.outTradeNo) params.outTradeNo = this.formInline.outTradeNo;
      if (this.formInline.timeData && this.formInline.timeData.length > 0) {
        params.startAt = changeDate(this.formInline.timeData[0]);
        params.endAt = changeDate(this.formInline.timeData[1]);
      }
      const { data, count } = await orderList(params);
      this.page.total = count;
      this.list = data;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
  },
};
</script>
